$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  const location_id = $("body").attr("event_id");

  if (p === "customer_contact_person") {
    const customer_id = $("body").attr("customer_id");
    let order_by = "name";
    let order_by_direction = "asc";
    $(document).on("submit", "#customer-search-form", function (e) {
      e.preventDefault();
      let search_string = $("#search_string").val();
      let page = 1;

      getCustomerContactPersonList(
        location_id,
        customer_id,
        search_string,
        page
      );
    });

    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();

      let page = parseInt($(this).attr("href").substring(6));
      let search_string = $("#search_string").val();

      getCustomerContactPersonList(
        location_id,
        customer_id,
        page,
        order_by,
        order_by_direction,
        search_string
      );
    });

    $(document).on("click", ".sort", function (e) {
      e.preventDefault();
      let page = $("#customer-table").attr("data-current-page");

      let search_string = $("#search_string").val();
      order_by = $(this).attr("data-order-by");
      order_by_direction = $(this).attr("data-order-by-direction");

      getCustomerContactPersonList(
        location_id,
        customer_id,
        page,
        order_by,
        order_by_direction,
        search_string
      );
    });

    function getCustomerContactPersonList(
      location_id = null,
      customer_id = null,
      page = 1,
      order_by,
      order_by_direction,
      search_string = ""
    ) {
      $.ajax({
        type: "POST",
        url: `/api/v1/private/customer-contact-person/search`,
        data: {
          location_id,
          customer_id,
          page,
          search_string,
          order_by,
          order_by_direction,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $("#customercontact-person-list-container").empty();
            $("#customercontact-person-list-container").append(data.html);
          }

          $("html,body").scrollTop(0);
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }
  }
});
